import {Component, Input} from '@angular/core';

@Component({
  selector: 'webu-preferred-dealer-save-notifications',
  templateUrl: './save-notifications-webu.html'
})
export class SaveNotificationsWebuComponent {
    @Input() status: string;
}
